import { createReducer } from "reduxsauce";
import _ from "lodash";
import ReducerRegister from "../../ReducerRegister";
import DefaultService from "../../../services/screens/chinesepark/DefaultService";
import { ActionTypes } from "../../actionTypes/screens/chinesepark/DefaultActionTypes";
import AsyncActionReducers from "../../AsyncActionReducers";

import UIDs from "../../../UIDs";

const uid = UIDs.screens.chinesepark.default;

//
// Actions
//
const Actions = {
    loadScreenViewAsync: () => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC });

            DefaultService.loadScreenView(
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: (data) => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error
    }),

    getRoomListAsync: (searchVO) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.GET_ROOMLIST_ASYNC, searchVO});

            DefaultService.getRoomList(
                {...searchVO},
                response => {
                    dispatch(Actions.getRoomListSuccess(response, searchVO));
                },
                error => {
                    dispatch(Actions.getAllRoomListFailure(error));
                }
            );
        };
    },

    getRoomListSuccess: (data, searchVO) => ({
        type: ActionTypes.GET_ROOMLIST_SUCCESS,
        parentType: ActionTypes.GET_ROOMLIST_ASYNC,
        postReducer: getRoomListSuccessPostReducer,
        data,
        searchVO
    }),

    getAllRoomListFailure: error => ({
        type: ActionTypes.GET_ROOMLIST_FAILURE,
        parentType: ActionTypes.GET_ROOMLIST_ASYNC,
        error
    }),
};

//
// Initial State
//
const INITIAL_STATE = {
    userInfo: {},
    roomList: [],
    pageCount: 0,
    totalCount: 0,
    searchVO:{
        searchType:1, //全部， pk, 口语对话， 会员
        pageSize: 50,
        pageIndex: 1,
        type: 0,
        vipRoom: 0,
        followed: 0,
        roomNo: "",
        email: "",
    }
};

//
// Reducers
//
const loadScreenViewSuccessPostReducer = (state, { data }) => {
    return { ...state, userInfo: data.userInfo };
};

const getRoomListSuccessPostReducer = (state, { data, searchVO }) => {
    return { ...state, searchVO, roomList: data.rooms, pageCount: data.pageCount, totalCount: data.totalCount };
};

// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.GET_ROOMLIST_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.GET_ROOMLIST_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.GET_ROOMLIST_FAILURE]: AsyncActionReducers.failureReducer,
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(uid, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
